import React from 'react';
import PropTypes from 'prop-types';
import EditorialSectionHead from '../../../molecules/EditorialSectionHead';
import './index.scss';

/**
 * Shared shell for the home-page editorial sections. Provides the standard
 * top/bottom padding, container, optional accent backdrop, and the section
 * head (eyebrow + title + side text).
 */
export default function HomeSection({
  id,
  eyebrow,
  title,
  side,
  showSide = true,
  variant = 'default',
  action,
  children,
  className = '',
}) {
  const classes = [
    'home-section',
    `home-section--${variant}`,
    className,
  ].filter(Boolean).join(' ');

  return (
    <section className={classes} id={id}>
      <div className="home-section__container">
        <EditorialSectionHead
          eyebrow={eyebrow}
          title={title}
          side={showSide ? side : null}
          action={action}
        />
        <div className="home-section__body">{children}</div>
      </div>
    </section>
  );
}

HomeSection.propTypes = {
  id: PropTypes.string,
  eyebrow: PropTypes.node.isRequired,
  title: PropTypes.node.isRequired,
  side: PropTypes.node,
  showSide: PropTypes.bool,
  variant: PropTypes.oneOf(['default', 'warm', 'cool', 'elev']),
  action: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
};
